import { FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { getAllOmraden } from 'components/search/common';
import { TextButton } from 'components/sharedElements/sharedElements';

import classnames from 'classnames';

const InventeringSearchCriterias: FC = () => {
  const { data: domaner } = useAppSelector((state: RootState) => state.bebyggelseobjektDomaner);
  const { data: aktivitetDomaner } = useAppSelector((state: RootState) => state.aktivitetDomaner);
  const { data: geo } = useAppSelector((state: RootState) => state.geo);
  const { data: utforare } = useAppSelector((state: RootState) => state.utforare);

  const [showCriterias, setShowCriterias] = useState<boolean>(true);
  const [statustyper, setStatustyper] = useState<string[] | undefined>();
  const [ansvarigaOrganisationer, setansvarigaOrgaisationer] = useState<string[] | undefined>();
  const [omraden, setOmraden] = useState<string[] | undefined>();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const statustyperParam = searchParams.get('aktivitetstatustyper');
    const ansvarigorganisationParam = searchParams.get('ansvarig_organisation');
    const kommunkodParam = searchParams.get('kommun_kod');
    const lankodParam = searchParams.get('lan_kod');

    if (statustyperParam) {
      const statusTyper = statustyperParam.split(',');
      const statusTyperMedNamn = aktivitetDomaner?.aktivitetstatustyper
        .filter((at) => statusTyper.some((ct) => ct === at.aktivitetstatustyp))
        ?.map((t) => t.namn);
      setStatustyper(statusTyperMedNamn);
    }

    if (ansvarigorganisationParam) {
      const organisationNummer = ansvarigorganisationParam.split(',');
      const organisationerMedNamn = utforare
        ?.filter((au) => organisationNummer.some((orgNummer) => orgNummer === au.organisationsnummer))
        ?.map((t) => t.namn);
      setansvarigaOrgaisationer(organisationerMedNamn);
    }

    setOmraden(Array.from(new Set(getAllOmraden(kommunkodParam, lankodParam, geo))));
  }, [domaner, geo, utforare, searchParams, aktivitetDomaner?.aktivitetstatustyper]);

  return (
    <div>
      <ul className={classnames('tw-mb-4 tw-text-size-0.813', { 'tw-hidden': !showCriterias })}>
        <li>
          <span className="tw-font-semibold">Ansvarig organisation:</span>{' '}
          <span className="tw-italic">
            {ansvarigaOrganisationer?.length ? ansvarigaOrganisationer?.join(', ') : 'Alla'}
          </span>
        </li>
        <li>
          <span className="tw-font-semibold">Område:</span>{' '}
          <span className="tw-italic">{omraden?.length ? omraden?.join(', ') : 'Alla'}</span>
        </li>
        <li>
          <span className="tw-font-semibold">Status:</span> <span className="tw-italic">{statustyper?.join(', ')}</span>
        </li>
      </ul>
      <TextButton
        onClick={() => setShowCriterias(!showCriterias)}
        icon={showCriterias ? 'raa-icon-arrow-up' : 'raa-icon-arrow-down'}
      >
        {showCriterias ? 'Dölj' : 'Visa'} sökkriterier
      </TextButton>
    </div>
  );
};

export default InventeringSearchCriterias;
